//----------------------------------------------------
// Translate `update_state` strings coming from the AI
// into front-end actions.  Now supports route refresh.
//----------------------------------------------------

import { listMarkets } from 'store/actions/marketsActions';
// import other thunks as needed

export default function routeUpdateState(flag, dispatch, clientId, router) {
  if (!flag) return;                       // "", null, undefined  ->  no-op

  // 1) Refresh a specific note detail
  if (typeof flag === 'string' && flag.startsWith('activity_note:')) {
    const id = Number(flag.split(':')[1]);
    // Tell the note page to re-fetch itself
    window.dispatchEvent(new CustomEvent('refresh-activity-note', { detail: { id } }));
    return;
  }

  /* ------------------------------------------------------------------
   * Registry : map back-end strings  →  front-end side-effects
   * ------------------------------------------------------------------ */
  const registry = {
    /* 1 ─ invalidate Redux slices (old behaviour) */
    markets: () => dispatch(listMarkets(clientId, { force: true })),
    activity_notes: () =>
      window.dispatchEvent(new Event('refresh-activity-notes')),
    '': () => {},
    /* 2 ─ special case: refresh the whole route for activity notes     */
    routermeunused: () => {
      /* if router.navigate exists, do a soft reload of the current URL
         so React Router remounts the page.  Fallback to hard reload.   */
      const nav = router?.navigate;
      if (typeof nav === 'function') {
        // same as pressing browser refresh on the current path
        nav(0);                // React-Router v6 way to reload
      } else {
        window.location.reload();
      }
    },

    /* 3 ─ explicit no-op keeps old default behaviour */
    '': () => {}
  };

  const fn = registry[flag];
  if (typeof fn === 'function') fn();
}